import Header from "./components/Header";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import BungalowExperience from "./components/BungalowExperience";
import ExperienceFeatures from "./components/ExperienceFeatures";
import Wellness from "./components/Wellness";
import Restaurant from "./components/Restaurant";
import NatureStory from "./components/NatureStory";
import Gallery from "./components/Gallery";
import ReservationForm from "./components/ReservationForm";
import Location from "./components/Location";
import InstagramSection from "./components/InstagramSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import MobileContactBar from "./components/MobileContactBar";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 pb-20 lg:pb-0">
      <Header />
      <main>
        <Hero />
        <Intro />
        <BungalowExperience />
        <ExperienceFeatures />
        <Wellness />
        <Restaurant />
        <NatureStory />
        <Gallery />
        <ReservationForm />
        <Location />
        <InstagramSection />
        <FinalCTA />
      </main>
      <Footer />
      <MobileContactBar />
    </div>
  );
}